(function (ws) {
    'use strict';
    ws.models.commentsModel = Backbone.Model.extend({

        /**
         * Initialize
         */
        initialize: function (options) {
            this.siteUid = options;
        },

        /**
         * Default value
         */
        defaults: {
            comment: '',
            code: ''
        },

        /**
         * Return Url
         */
        url: function () {
            return this.siteUid + globals.path.api.quoting.saveCommentUrl.replace('{quoteId}', !_.isUndefined(this.get('quoteId')) ? '/' + this.get('quoteId') : '');
        }
    });
})(westcon);
